import React, { useEffect } from 'react'
import { StyleSheet, Text } from 'react-native'
import { BtAlert, BtRadioGroup } from '@linqpal/components/src/ui'
import { useResponsive } from '@linqpal/components/src/hooks'
import { useTranslation } from 'react-i18next'
import { PURCHASE_TYPE } from '@linqpal/models/src/dictionaries'
import { observer } from 'mobx-react-lite'
import {
  MESSAGE_TYPE,
  useMessage,
} from '../../../utils/helpers/MessageProvider'
import InvoiceActionsStore from './InvoiceActionsStore'

export const SelectPurchaseType = observer(() => {
  const { t } = useTranslation('global')
  const { sm } = useResponsive()
  const { setMessage } = useMessage()
  const {
    selectPurchaseType,
    setSelectPurchaseType,
    setChosenPurchaseType,
    chosenPurchaseType,
  } = InvoiceActionsStore
  const { resumeApplyingForLoan, startProjectFlow } = InvoiceActionsStore
  const onClose = () => {
    setSelectPurchaseType(false)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setChosenPurchaseType(null), [])
  const options = [
    {
      label: t('SelectPurchaseType.inventory'),
      value: PURCHASE_TYPE.INVENTORY,
    },
    {
      label: t('SelectPurchaseType.specific-project'),
      value: PURCHASE_TYPE.PROJECT,
    },
  ]
  const onContinue = () => {
    onClose()
    if (chosenPurchaseType === PURCHASE_TYPE.INVENTORY) resumeApplyingForLoan()
    else if (chosenPurchaseType === PURCHASE_TYPE.PROJECT) {
      startProjectFlow()
    } else {
      setMessage(MESSAGE_TYPE.ERROR, 'Purchase type not selected')
    }
  }
  return (
    <BtAlert
      visible={selectPurchaseType}
      onClose={onClose}
      buttons={[
        {
          label: 'Go Back',
          appearance: 'outline',
          style: sm ? styles.buttonDesktop : styles.buttonMobile,
          onPress: onClose,
          disabled: !chosenPurchaseType,
        },
        {
          label: 'Continue',
          style: sm ? styles.buttonDesktop : styles.buttonMobile,
          onPress: onContinue,
          disabled: !chosenPurchaseType,
        },
      ]}
      width={sm ? 650 : undefined}
      buttonsContainerStyle={sm && { justifyContent: 'center' }}
    >
      <Text style={sm ? styles.desktopTitleStyle : styles.mobTitleStyle}>
        {t('SelectPurchaseType.title')}
      </Text>
      <BtRadioGroup
        value={chosenPurchaseType}
        options={options}
        onChange={(val) => setChosenPurchaseType(val)}
        radioStyle={{ marginRight: 32 }}
        groupStyle={{
          flexDirection: sm ? 'row' : 'column',
          marginBotton: 35,
          justifyContent: 'center',
        }}
        testID="purchase-type"
      />
    </BtAlert>
  )
})

const styles = StyleSheet.create({
  desktopTitleStyle: {
    fontWeight: '700',
    fontSize: 28,
    lineHeight: 36,
    color: '#003353',
    marginBottom: 25,
    width: 493,
    textAlign: 'center',
  },
  mobTitleStyle: {
    fontWeight: '600',
    fontSize: 18,
    lineHeight: 28,
    color: '#003353',
    textAlign: 'center',
    marginBottom: 11,
  },
  buttonDesktop: {
    width: 210,
    marginBottom: 40,
    marginRight: 5,
    marginLeft: 5,
  },
  buttonMobile: {
    minWidth: 140,
    marginRight: 5,
    marginLeft: 5,
  },
})
